import { jsx as _jsx } from "react/jsx-runtime";
import TutorPage from "./TutorPage";
export default function DivisionPage() {
    return _jsx(TutorPage, { initialTopic: "Division", lockTopic: true });
}
